<template>
    <div>
        <div class="custom-search d-flex justify-content-end mb-1">
            <div class="float-left mr-auto">
                <b-button
                        variant="primary"
                        @click="newEntity"
                >
                    <span class="text-nowrap">Hozzáadás</span>
                </b-button>
            </div>
        </div>

        <!-- table -->
        <vue-good-table
                mode="remote"
                :columns="columns"
                :rows="rows"
                :rtl="direction"
                :pagination-options="{
          enabled: true,
          perPage: pageLength
        }"
                :sort-options="{
          enabled: true,
          multipleColumns: true,
          initialSortBy: sortBy,
        }"
                @on-row-click="onRowClick"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
        >
            <div slot="emptystate">
                <div class="vgt-center-align vgt-text-disabled">
                    {{ $t('table.list.empty') }}
                </div>
            </div>
            <template
                    slot="table-row"
                    slot-scope="props"
            >

        <span class="text-nowrap" v-if="props.column.field === 'gross_price'">
          <span class="text-nowrap">{{ $formatters.formatPriceText(props.row.gross_price) }} Ft</span>
        </span>

                <!-- Column: Action -->
                <span v-else-if="props.column.field === 'action'">
                <span v-if="$acl.canEditPermission(role)">
                  <b-button
                          size="sm"
                          variant="primary"
                          @click.stop="$router.push({ name: 'modify-reservation-pricing-base-variable-fee', params: { id: props.row.id }})"
                  >
                    <feather-icon
                            icon="EditIcon"
                    />
                  </b-button>
                </span>
                <span v-if="$acl.canDeletePermission(role)">
                  <b-button
                          size="sm"
                          variant="danger"
                          class="ml-1"
                          @click.stop="deleteEntity(props.row.id, $event, props.row.deletable)"
                  >
                    <feather-icon
                            icon="XCircleIcon"
                    />
                  </b-button>
                </span>
              </span>

                <!-- Column: Common -->
                <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>

            <!-- pagination -->
            <template
                    slot="pagination-bottom"
                    slot-scope="props"
            >
                <div class="d-flex justify-content-between flex-wrap">
                    <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">
              {{ ((page - 1) * pageLength) + 1 }} +
            </span>
                        <b-form-select
                                v-model="pageLength"
                                :options="pages"
                                class="mx-1"
                                @change="handlePageChange"
                        />
                        <span class="text-nowrap "> a {{ dataFromServer.total }} találatból </span>
                    </div>
                    <div>
                        <b-pagination
                                :value="1"
                                :total-rows="dataFromServer.total"
                                :per-page="dataFromServer.per_page"
                                first-number
                                last-number
                                align="right"
                                prev-class="prev-item"
                                next-class="next-item"
                                class="mt-1 mb-0"
                                @change="handleChangePage"
                        >
                            <template #prev-text>
                                <feather-icon
                                        icon="ChevronLeftIcon"
                                        size="18"
                                />
                            </template>
                            <template #next-text>
                                <feather-icon
                                        icon="ChevronRightIcon"
                                        size="18"
                                />
                            </template>
                        </b-pagination>
                    </div>
                </div>
            </template>
        </vue-good-table>
    </div>
</template>

<script>
import {
    BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, BButton, BAlert,
} from 'bootstrap-vue'
import {VueGoodTable} from 'vue-good-table'
import store from '@/store/index'

export default {
    components: {
        VueGoodTable,
        BAvatar,
        BBadge,
        BPagination,
        BFormGroup,
        BFormInput,
        BFormSelect,
        BDropdown,
        BDropdownItem,
        BButton,
        BAlert,
    },
    data() {
        return {
            role: 'reservation',
            pageLength: 10,
            dir: false,
            pages: ['10', '20', '50'],
            columns: [
                {
                    label: 'Érvényesség kezdete',
                    field: 'valid_from',
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Érvényesség kezdete szerinti szűrés'
                    },
                },
                {
                    label: 'Árazás típus',
                    field: 'pricingTypeName',
                    sortable: false,
                    filterOptions: {
                        enabled: false,
                    },
                },
                {
                    label: 'Kezdés napja',
                    field: 'start_day_type',
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Kezdés napja szerinti szűrés',
                    },
                },
                {
                    label: 'Napok száma',
                    field: 'daysFromTo',
                    sortable: false,
                    filterOptions: {
                        enabled: false,
                    },
                },
                {
                    label: 'Résztvevők száma',
                    field: 'participantsFromTo',
                    sortable: false,
                    filterOptions: {
                        enabled: false,
                    },
                },
                {
                    label: 'Ár',
                    field: 'gross_price',
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: 'Ár szerinti szűrés',
                    },
                },
            ],
            rows: [],
            page: 1,
            sortBy: [
                {
                    field: 'valid_from',
                    type: 'desc',
                },
                {
                    field: 'min_number_of_days',
                    type: 'asc'
                },
                {
                    field: 'min_number_of_participants',
                    type: 'asc'
                },
                {
                    field: 'start_day_type',
                    type: 'desc',
                },
            ],
            dataFromServer: [],
        }
    },
    computed: {
        direction() {
            if (store.state.appConfig.isRTL) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.dir = true
                return this.dir
            }
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.dir = false
            return this.dir
        },
    },
    created() {
        let storedPageLength = localStorage.getItem('pageLength')
        if (storedPageLength) {
            this.pageLength = storedPageLength
        }

        if (this.$acl.canEditPermission(this.role) || this.$acl.canDeletePermission(this.role)) {
            const actions = [
                {
                    label: this.$t('table.header.actions'),
                    field: 'action',
                    sortable: false,
                    width: '10rem',
                },
            ]

            this.columns = [...this.columns, ...actions]
        }

        this.initEntities()
    },
    methods: {
        initEntities() {
            const searchParams = {
                page: parseInt(this.page),
                limit: parseInt(this.pageLength),
                query: this.searchTerm,
                columnFilters: this.columnFilters,
                sort: this.sortBy,
            }

            this.$store.dispatch('fetchReservationPricingBaseVariableFees', searchParams).then(response => {
                this.rows = response.data.entities.data
                this.dataFromServer = response.data.entities
                this.page = this.dataFromServer.current_page
                this.pageLength = parseInt(this.dataFromServer.per_page)
            })
        },
        onRowClick(params) {
            if (this.$acl.canEditPermission(this.role))
                this.$router.push({name: 'modify-reservation-pricing-base-variable-fee', params: {id: params.row.id}})
        },
        handleChangePage(page) {
            this.page = page
            this.initEntities()
        },
        handlePageChange(active) {
            this.pageLength = active
            localStorage.setItem('pageLength', active)
            this.page = 1
            this.handleChangePage()
        },
        newEntity() {
            this.$router.push({name: 'add-reservation-pricing-base-variable-fee'})
        },
        deleteEntity(id, event, deletable) {
            if (deletable) {
                this.$bvModal
                    .msgBoxConfirm('Biztosan törölni szeretnéd?', {
                        title: 'Jóváhagyás',
                        size: 'sm',
                        okVariant: 'primary',
                        okTitle: 'Igen',
                        cancelTitle: 'Nem',
                        cancelVariant: 'outline-secondary',
                        hideHeaderClose: false,
                        centered: true,
                    })
                    .then(value => {
                        if (value) {
                            // axios
                            this.$store.dispatch('deleteReservationPricingBaseVariableFee', id).then(() => {
                                this.initEntities(1)
                                this.$helpers.showSuccessToast(`Sikeres törlés (${id})`)
                            })
                        }
                    })
            } else {
                this.$helpers.showErrorToast('Az alapdíj tétel nem törölhető, mert erre a tárgyévre vonatkozóan ezekkel a paramérerekkel ez az egyetlen.')
            }
        },
        onSortChange(params) {
            this.page = 1
            this.sortBy = params[0]
            this.initEntities()
        },
        onColumnFilter(params) {
            this.page = 1
            this.columnFilters = params.columnFilters
            this.initEntities()
        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
